import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import commandEngine from './CommandEngine';
import { CMD_RISKPROFILE_REGISTRY_KEY, META_TYPE, META_VER } from './riskProfileCommandRegisteryType';

/**
 * Registers the /risk command with the CommandEngine.
 * Call once at module load from YourLibraryTab (via CommandEngine.bootup).
 *
 * /risk profiles — opens the RiskProfileWidget card.
 */
export function registerRiskProfileCommand() {
    commandEngine.register('/risk', {
        hint: 'Open risk profiles',
        params: [{ name: 'view', options: [{ label: 'Profiles', value: 'profiles' }] }],
        handler: () => {
            cardPainterManager.openCard(CMD_RISKPROFILE_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: 'global' });
        },
    });
}
